import React, { useState, useEffect } from 'react';
import FormClienteGrid from './FormClienteGrid.js'; 
//import {SvgVolta} from '../Svg.js';

const FormCli = () => {
const [isLoggedIn, setIsLoggedIn] = useState(false);

useEffect(() => {
    const sessionStatus = sessionStorage.getItem('isLoggedIn');
    if (sessionStatus === 'true') {
      setIsLoggedIn(true);
    }
}, []);
return (
<div class = "recipiente">
    {isLoggedIn ? (
        <FormClienteGrid/>
    ) : (
      <p>Retorne para a Área Restrita</p>
    )
    }
</div>
)
};
 
export default FormCli;
  